import { render, staticRenderFns } from "./compInfo.vue?vue&type=template&id=0bb8dcd3&scoped=true&"
import script from "./compInfo.vue?vue&type=script&lang=js&"
export * from "./compInfo.vue?vue&type=script&lang=js&"
import style0 from "./compInfo.vue?vue&type=style&index=0&id=0bb8dcd3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb8dcd3",
  null
  
)

export default component.exports